// SPDX-FileCopyrightText: 2023 Genome Research Ltd.
//
// SPDX-License-Identifier: MIT
import { useEffect, useRef } from 'react';
// ignores the initial load update
export function useEffectUpdate(fn, dependencies) {
    var isMountingRef = useRef(false);
    useEffect(function () {
        isMountingRef.current = true;
    }, []);
    useEffect(function () {
        if (!isMountingRef.current) {
            return fn();
        }
        else {
            isMountingRef.current = false;
        }
    }, dependencies);
}
